/**
 * DetailsRow - Handles expandable table row details
 */
export class DetailsRow {
    constructor() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.addEventListener('click', (e) => {
            const viewDetailsBtn = e.target.closest('table .view-details');
            if (viewDetailsBtn) {
                e.preventDefault();
                this.toggleDetails(viewDetailsBtn);
            }
        });
    }

    toggleDetails(button) {
        const parentTr = button.closest('tr');
        if (!parentTr) return;

        let nextTr = parentTr.nextElementSibling;
        
        // Skip non-element nodes
        while (nextTr && !nextTr.classList.contains('details-row')) {
            nextTr = nextTr.nextElementSibling;
        }

        if (nextTr) {
            nextTr.classList.toggle('active');
        }
    }
}

